import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
export function ProgressBar(t0) {
  const $ = _c(6);
  const {
    percent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${percent}%`;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      width: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.3,
      ease: [0.32, 0.72, 0, 1]
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className="h-1 w-full bg-surface-weak rounded-full overflow-hidden"><motion.div className="h-full rounded-full bg-surface-foreground" initial={t1} animate={t3} transition={t4} /></div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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